import {TYPES_USED_PLATFROM} from '../../constants/redemptionPlatform';
import {
  MEMBERSHIP_TICKET_COLOR,
  MEMBERSHIP_TICKET_LABEL,
  MEMBERSHIP_TICKET_STATUS,
} from '../../constants/status';

export const REDEEMED_PROCESS_ID_ENUM = {
  SUCCESSFUL: 1,
  DECLINED: 3,
};

export const REDEEMED_PROCESS_ID_LABEL = {
  [REDEEMED_PROCESS_ID_ENUM.SUCCESSFUL]: 'Successful',
  [REDEEMED_PROCESS_ID_ENUM.DECLINED]: 'Declined',
};

export const REDEEMED_PROCESS_ID_COLOR = {
  [REDEEMED_PROCESS_ID_ENUM.SUCCESSFUL]: 'success',
  [REDEEMED_PROCESS_ID_ENUM.DECLINED]: 'error',
};

export const getUseVoucherStatusData = (value: any, config: any = {}) => {
  const {colors = MEMBERSHIP_TICKET_COLOR} = config;
  const state = value?.voucherStatus;

  if (
    value?.redeemedProcessId !== REDEEMED_PROCESS_ID_ENUM.SUCCESSFUL ||
    state === null ||
    !(state in MEMBERSHIP_TICKET_LABEL)
  ) {
    return {
      label: '--',
    };
  }

  return {
    label: MEMBERSHIP_TICKET_LABEL[state],
    color: colors[state] || 'default',
  };
};
